import React from "react";
import {
    DataGrid,
    FilterRow,
    Editing,
    Column,
    Paging,
    Pager
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import PaginaToolbar from "../components/PaginaToolbar";
import { criarNaturezaJuridicaDs } from "../DataSources";

export default class NaturezasJuridicasBox extends React.Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className={'content-block dx-card responsive-paddings'}>
                <PaginaToolbar titulo="NATUREZAS JURÍDICAS">
                    <DataGrid
                        dataSource={criarNaturezaJuridicaDs()}
                        showBorders={true}
                        rowAlternationEnabled={true}
                        remoteOperations={true}
                        wordWrapEnabled={true}
                        columnAutoWidth={true}
                        focusedRowEnabled={true}>
                        <FilterRow visible={true} />
                        <Editing mode={"row"} allowAdding={false} allowUpdating={true} allowDeleting={true} />
                        <Column dataField={"id"} caption="#" />
                        <Column dataField={'descricao'} caption={"Descrição"} wordWrapEnabled={true} />
                        <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                        />
                    </DataGrid>
                </PaginaToolbar>
            </div>
        );
    }
}